module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/pURA53/tc-custom/9781612431512.jpg?1726617300318",
      "alt": "This image is the cover for the book 7 Weeks to 10 Pounds of Muscle"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("7 Weeks to 10 Pounds of Muscle\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("BUILD MASSIVE MUSCLES."), _c('br'), _c('br'), _vm._v(" Follow the day-by-day plan in this book and you will finally achieve the body you’ve always wanted. Packed with clear charts and helpful photos, this book has everything you need to bulk up:"), _c('br'), _c('br'), _vm._v(" •Easy-to-follow workouts"), _c('br'), _vm._v(" •Step-by-step lifting instructions•"), _c('br'), _vm._v(" Meal plan for maximum muscle growth"), _c('br'), _c('br'), _vm._v(" The "), _c('i', [_vm._v("7 Weeks to 10 Pounds of Muscle")]), _vm._v(" program takes less than 2 hours per week and requires just three simple ingredients: a can-do spirit, a carefully crafted exercise routine and a solid nutritional regimen. Offering field-tested programs and delicious muscle-building recipes, "), _c('i', [_vm._v("7 Weeks to 10 Pounds of Muscle")]), _vm._v(" shows how quickly you can get strong and sculpted. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Brett Stewart, Jason Warner\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Ulysses Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0